<template>
  <AlertCard
    v-if="!loading && user && hasOpenQuotes && quoteId"
    data-id="open-quote-alert"
    :variant="Variant.warning"
    :title="'Open quote'"
    :links="[
      {
        to: `/upgrade/quote/${quoteId}`,
        text: 'View quote',
      },
    ]"
    :text="'You have an open quote that requires completion. Please accept the quote to complete your upgrade.'"
  />
  <AlertCard
    v-else-if="!loading && user && hasPaymentFailures"
    :title="'Payment failures'"
    :variant="Variant.danger"
    :links="[
      {
        href: dashboardBtn,
        text: 'Open billing',
      },
    ]"
    :text="'Your account has unpaid invoices or failed payments. Please open the billing portal to review your payments.'"
  />
</template>
<script setup lang="ts">
import { loadFetch, loadFetchMany } from '../../lib/services/helpers';
import { computed, onMounted, ref } from 'vue';

import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import { Variant } from '../../store/types';
import AlertCard from '../../components/tw/AlertCard.vue';

const store3 = useStore3();
const { user } = storeToRefs(store3);

const loading = ref(false);

const { billingPortal, isChild, openQuotes, paymentFailures } =
  storeToRefs(store3);

onMounted(async () => {
  await loadFetchMany(
    [
      () => store3.getSubscription(),
      isChild.value ? undefined : () => store3.getOpenQuotes(),
      isChild.value ? undefined : () => store3.getPaymentFailures(),
    ].filter((it) => !!it),
    store3,
    loading,
  );
  if (hasPaymentFailures.value) {
    await loadFetch(() => store3.getBillingPortal(), store3, loading);
  }
});

const hasPaymentFailures = computed(() => {
  return (paymentFailures.value?.length ?? 0) > 0;
});

const dashboardBtn = computed(() => {
  return billingPortal.value?.url ?? '/settings/';
});

const quoteId = computed(() => {
  return openQuotes.value?.quotes?.[0]?.id;
});

const hasOpenQuotes = computed<boolean>(() => {
  return openQuotes.value?.hasOpenQuotes ?? false;
});
</script>
